import React, {useState} from 'react';

import DomainTablePage from '../../components/domainTablePage.js'

import {TechnologyWebsitePageResult} from '../../../../server/routes/technology.js'

interface TechnologyWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function TechnologyWebsites({server, pageData}: TechnologyWebsitesProps) {

	const typedPageData = pageData as TechnologyWebsitePageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <DomainTablePage 
            domainList={data.TechnologyDomains}
        />
	)
}
